import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { EnumVerificationStatus } from '@pages/sales-marketing/program-marketing-legacy/program-marketing.enum';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ProgramMarketingDistributorService } from '@pages/sales-marketing/program-marketing/program-marketing-distributor/program-marketing-distributor.service';

@Component({
  selector: 'app-section-verified-badge',
  standalone: true,
  imports: [InlineSVGModule],
  template: `
    <span class="svg-icon svg-icon-3 me-1" [inlineSVG]="badgeIcon"></span>
    <span class="fs-7 fw-bolder" [class.text-primary]="isNotHaveRevision || isVerifiedOrNoChanges" [class.text-danger]="isSectionDeleted || isRequestRevision"
      >{{ badgeText }}
    </span>
  `,
  styleUrls: ['./section-verified-badge.component.scss'],
})
export class SectionVerifiedBadgeComponent implements OnInit {
  @HostBinding('class') classes = 'ms-2';

  @Input() sectionVerificationStatus!: EnumVerificationStatus | null;
  @Input() isRequestRevision!: boolean;
  @Input() isNotHaveRevision!: boolean;
  @Input() isSectionDeleted!: boolean;
  @Input() isViewOnly!: boolean; // no badge icon/text should be rendered

  @Input() textVerified = 'Diverifikasi';
  @Input() textRevision = 'Perlu Perbaikan';
  @Input() textNotHaveRevision = 'Tidak Ada Perubahan';

  /** When set, overrides the computed badge text (still hidden for view-only/deleted sections). */
  @Input() customNote?: string | null;

  isViewLog = false;

  get badgeText() {
    // console.log('get badge text ', this.sectionVerificationStatus);
    // Jika view-only atau section dihapus, badge kosong
    if (this.isViewOnly || this.isSectionDeleted) {
      return '';
    }

    // Teks kustom mengesampingkan teks default
    if (this.customNote) {
      return this.customNote;
    }

    // Jika status verifikasi ada
    if (this.sectionVerificationStatus) {
      // kalo status verified dan menggunakan flag isNotHaveRevision
      if (this.sectionVerificationStatus === EnumVerificationStatus.VERIFIED && this.isNotHaveRevision) return this.textNotHaveRevision;
      return this.sectionVerificationStatus === EnumVerificationStatus.VERIFIED ? this.textVerified : this.textRevision;
    }

    // Jika tidak ada status verifikasi
    return this.isNotHaveRevision ? this.textNotHaveRevision : '';

    // if (!!this.sectionVerificationStatus) {
    //   if (this.isViewOnly || this.isSectionDeleted) {
    //     return '';
    //   } else {
    //     return this.sectionVerificationStatus === EnumVerificationStatus.VERIFIED ? this.textVerified : this.textRevision;
    //   }
    // } else {
    //   return this.isNotHaveRevision ? this.textNotHaveRevision : '';
    // }
  }

  get badgeIcon() {
    // console.log('get badge icon ', this.sectionVerificationStatus);
    if (!!this.sectionVerificationStatus) {
      if (this.isViewOnly || this.isSectionDeleted) {
        return '';
      } else {
        return this.sectionVerificationStatus === EnumVerificationStatus.VERIFIED ? STRING_CONSTANTS.ICON['IC_BULLET_TICK_GREEN'] : STRING_CONSTANTS.ICON['IC_DANGER'];
      }
    } else {
      return this.isNotHaveRevision ? STRING_CONSTANTS.ICON['IC_BULLET_TICK_GREEN'] : STRING_CONSTANTS.ICON['IC_DANGER'];
    }
  }

  get isVerifiedOrNoChanges() {
    // status null || VERIFIED // dont have revision note
    return this.sectionVerificationStatus === EnumVerificationStatus.VERIFIED || this.sectionVerificationStatus === null;
  }

  constructor(private programService: ProgramMarketingDistributorService) {}

  ngOnInit() {
    this.isViewLog = this.programService.IsCurrentViewModeLog;
  }

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
  protected readonly EnumVerificationStatus = EnumVerificationStatus;
}
